<template>

    <div class="TQ_center">

        <!-- top Image-->
        <tq-on-top-container v-if="!co_mobileSize_b" :style="{'background': `url(${ass_img_oldMapCompass}`}" class="TQ_font_SecularOne TQ_textColor_white TQ_height_350px">

            <div slot="middle" class="TQ_maxWidth_100vw-8px TQ_borderBox TQ_center TQ_text_capitalize" >

                <div>

                    <h1 class="TQ_borderRadius TQ_text_shadow lc_title1"
                        :class="!co_mobileSize_b ? 'TQ_text_100px' : 'TQ_text_60px'">
                        {{ass_strings.twoWords_travelQuest[store_system_langCode_v.val]}}
                    </h1>

                    <h2  class="TQ_borderRadius TQ_text_shadow"
                         :class="!co_mobileSize_b ? 'TQ_text_50px' : 'TQ_text_32px'">

                        <!--travel diffrent-->
                        <!--Transform your traveling experience into adventure quest-->
                        <!--Traveling adventures-->
                        <!--Changing the way we travel-->
                        <!--Transform Traveling experience into intertwining quests-->

                        <!--{{ ass_strings.sentence_storeTitle1[store_system_langCode_v.val]}}-->


                        <!--לבצע משימות, לפתור חידות, לנווט ליעדים-->
                        <!--<br>-->
                        <!--תיירות דרך משחק אינטרקטיבי-->

                        <!--Do Missions, Solve Riddles, Navigate to destinations,-->
                        <!--<br>-->
                        <!--Tour with an interactive game-->

                        <!--מבצעים משימות, פותרים חידות, מנווטים ליעדים-->
                        <!--<br>-->
                        <!--תיירות - משחקית - שיתופית-->

                        <!--תיירות דרך משחק אינטרקטיבי חוויתי-->
                        <!--<div class="TQ_text_40px">-->
                        <!--   בצעו משימות, פתרו חידות, נווטו ליעדים-->
                        <!--</div>-->
                        <!--תיירות דרך משחק אינטרקטיבי-->

                        <!--לנווט, לבצע משימות, ולפתור חידות-->
                        <!--לנווט, לבצע משימות, לפתור חידות - תירות אחרת-->
                        <!--בצעו משימות ופתרו חידות-->
                        <!--משחקים אינטראקטיבים חוויתיים-->
                        <!--פעילות יוצאות דופן-->
                        <!--<br>-->
                        <!-- - -->
                        <!--הנוצרות על ידי מקומים-->
                        <!--תיירות אחרת-->
                        <!--לראות, לחוות דרך פעילות משחקית-->
                        <!--לראות, לחוות דרך פעילות משחקית-->

                        <!--לנווט, לבצע משימות ולפענח חידות - תיירות דרך משחק אינטרקטיבי-->


                        <!--תיירות חברתית, הצטרפו לפעילויות יחודיות ומקוריות-->

                        <!--תיירות חברתית יוצרת-->

                        <!--Social Tourism,-->

                        <!--Platform For People To Create and Share there content-->
                        <!--Social Tourism, Discover places in a unique and interactive way-->

                        <!--People Share Content, <br>-->
                        <!--Discover places in a unique and interactive way.-->

                        <!--תיירות חברתית - -->
                        <!--גלו מקומות בדרך יחודית ואינטרקטיבית-->
                        <!--אנשים יוצרים ומשתפים-->

                        <!--חברה יוצרת תיירות - לגלות מקומות בצורה אחרת-->
                        <!--Society Create Tourism - Discover places in a different way-->
                        <!--Society Tourism - Discover places in a different way-->

                        <!--Social Tourism, Experience Unique And Exciting Activities-->

                        <!--Social Torisume Interactive Activities Created By -->

                        <!--Social, Native, New  tourism,-->
                        <!--תיירות חברתיתי, מקומית, יוצרת.-->

                        <!--Marketplace For Interactive Activities-->
                        <!--שוק לפעילויות אינטראקטיביות-->
                    </h2>

                </div>

            </div>
        </tq-on-top-container>

        <!-- totals -->
        <div v-if="false" class="TQ_margin_bottom_8px TQ_bg_white TQ_padding_32px_0px TQ_font_SecularOne"
             :class="!co_mobileSize_b ? 'TQ_text_32px' : 'TQ_text_24px'">

            <div class="TQ_grid_col_1fr1fr1fr TQ_grid_gap_16px TQ_maxWidth_900px TQ_center" >

                <div class="TQ_maxWidth_250px TQ_center TQ_width_100p">
                    <div class="TQ_border_bottom">
                        {{ass_strings.oneWord_players[store_system_langCode_v.val]}}
                    </div>
                    <div class="">
                        31,443
                    </div>
                </div>

                <div class="TQ_maxWidth_250px TQ_center TQ_width_100p">
                    <div class="TQ_border_bottom">
                        {{ass_strings.oneWord_quests[store_system_langCode_v.val]}}
                    </div>
                    <div class=" ">
                        46
                    </div>
                </div>

                <div class="TQ_maxWidth_250px TQ_center TQ_width_100p">
                    <div class="TQ_border_bottom">
                        {{ass_strings.oneWord_languages[store_system_langCode_v.val]}}
                    </div>
                    <div class="">
                        6
                    </div>
                </div>
            </div>

        </div>

        <!-- about us -->
        <div class="TQ_bg_white TQ_padding_16px TQ_font_SecularOne TQ_text_24px">

            <Div class="TQ_maxWidth_1200px TQ_center">

                <div class="TQ_text_capitalize">
                    <Div class="TQ_text_bold TQ_text_28px">{{ass_strings.sentenceGroup_storeSubTitle1[store_system_langCode_v.val]}}</div>
                    <div>{{ass_strings.sentenceGroup_storeSubTitle2[store_system_langCode_v.val]}}</div>
                    <div class="TQ_padding_4px"></div>
                    <div>{{ass_strings.sentenceGroup_storeSubTitle3[store_system_langCode_v.val]}}</div>
                    <div>{{ass_strings.sentenceGroup_storeSubTitle4[store_system_langCode_v.val]}}</div>
                </div>



                <div>
                    <!--<div class="TQ_inline TQ_clickable TQ_link TQ_padding_8px">-->
                    <!--    Find Existing Quest-->
                    <!--</div>-->

                    <!--<div class="TQ_inline TQ_clickable TQ_link TQ_padding_8px_16px">-->
                    <!--    Create New Quest-->
                    <!--</div>-->

                    <!--<div class="TQ_inline TQ_clickable TQ_link TQ_padding_8px">-->
                    <!--    More About Us-->
                    <!--</div>-->

                </div>


            </Div>



        </div>

        <!-- space -->
        <div v-if="!co_mobileSize_b" class="TQ_padding_16px"></div>

        <!-- categories -->
        <div >

            <div v-for="category in categories_ao" class="TQ_inline TQ_verticalAlignTop TQ_padding_8px">
                <div class="TQ_maxWidth_500px TQ_width_100p TQ_box_shadow TQ_bg_white TQ_padding_8px TQ_borderBox TQ_borderRadius TQ_bg_hover_shadow2 ">

                    <tq-link :p_link_s="category.path_s"
                             class="TQ_text_remove_underline TQ_textColor_black  TQ_borderRadius">

                        <tq-on-top-container>
                            <tq-image slot="body" :pb_src_r="category.img_r" class="TQ_borderRadius TQ_width_100p"/>

                            <div slot="middle" class="TQ_text_60px TQ_text_capitalize TQ_textColor_white TQ_text_shadow TQ_font_SecularOne">
                                {{ category.title_blc_s[store_system_langCode_v.val] }}
                            </div>

                        </tq-on-top-container>


                        <div class="TQ_align_initial TQ_font_SecularOne">

                            <div class="TQ_margin_bottom_4px TQ_margin_top_4px TQ_text_bold TQ_text_capitalize TQ_text_24px ">
                                {{ category.title_blc_s[store_system_langCode_v.val] }}
                            </div>

                            <div class="">
                                {{ category.description_blc_s[store_system_langCode_v.val] }}
                            </div>
                        </div>

                    </tq-link>



                </div>
            </div>


        </div>

        <!-- spacing -->
        <div class="TQ_padding_16px"></div>

        <!-- quests -->
        <tq-loader-container :p_show-loader_b="showLoader_questsExplores_b" :p_tq-loader_b="true">

            <!-- title -->
            <div class="TQ_text_32px TQ_margin_top_16px TQ_font_SecularOne TQ_bg_white TQ_margin_bottom_8px TQ_padding_8px">
                {{ass_strings.oneWord_quests[store_system_langCode_v.val]}}
            </div>

            <c_-player_-store_-list
                class="TQ_padding_8px"
                v-if="!showLoader_questsExplores_b"
                :p_more-quest-btn-loader_b="false"

                :p_system-lang-code_e="store_system_langCode_v.val"
                :p_system-currency_e="store_system_currency_v.val"
                :p_system-window-size-type_e="store_system_windowSizeType_ve.val"
                :p_screen-width_n="store_screenWidth_vn.val"

                :p_creators-data_by-user-id_c="server_creatorData_byUserId_c"
                :p_loved-quests_by-quest-id_c="server_lovedQuests_byQuestId_c"
                :p_quest-explore-info_by-quest-id_c="server_questExploreInfo_byQuestId_c"
                :p_quests-explore_ac="server_questsExplore_ac"

                :pe_click-love-quest_f="m_clickLoveQuest_f"
            />

        </tq-loader-container>

        <!-- spacing -->
        <div class="TQ_padding_16px"></div>

        <!-- creators -->
        <div >
            <div class="TQ_text_32px TQ_margin_top_16px TQ_font_SecularOne TQ_bg_white TQ_text_capitalize">
                {{ ass_strings.twoWords_questsCreators[store_system_langCode_v.val] }}
            </div>

            <div class="TQ_scrollable TQ_padding_8px">

                <table class="TQ_width_100p" :class="store_system_windowSizeType_ve.val > enum_screenSizesOptions_n.mobile && 'TQ_maxWidth_1500px TQ_center'">

                    <td class="TQ_verticalAlignMiddle" :class="store_system_windowSizeType_ve.val > enum_screenSizesOptions_n.mobile && 'TQ_inline'" v-for="creatorMoreInfo_c in server_creatorMoreInfo_byUserId_c" >
                        <tq-link v-if="server_creatorData_byUserId_c[creatorMoreInfo_c.udsmi_userId_uid]"
                                 :p_link_s="enum_moveToOptions.player_store_creator + '/' + server_creatorData_byUserId_c[creatorMoreInfo_c.udsmi_userId_uid].ud_m_getUrlFromEmail_fs()"
                                 class="TQ_textColor_black TQ_text_remove_underline">

                            <div  class="TQ_borderRadius TQ_padding_8px TQ_bg_white TQ_margin_4px TQ_box_shadow TQ_width_300px TQ_bg_hover_shadow2" >

                                <div class="TQ_grid_col_auto1fr TQ_margin_top_4px TQ_grid_gap_8px">

                                    <fcc-avatar :p_ud_avatar_c="server_creatorData_byUserId_c[creatorMoreInfo_c.udsmi_userId_uid].ud_avatar_c"
                                                :key="$options.name + creatorMoreInfo_c.udsmi_userId_uid"
                                                class="TQ_width_64px TQ_borderRadius  TQ_inline"/>

                                    <div class="TQ_align_initial ">

                                        <div class="TQ_margin_bottom_4px  ">
                                            <div class="TQ_text_20px TQ_text_bold">
                                                {{server_creatorData_byUserId_c[creatorMoreInfo_c.udsmi_userId_uid].ud_name_s}}
                                            </div>

                                            <div>
                                                <div class="TQ_bg_purple_lite TQ_borderRadius TQ_inline TQ_padding_0px_8px">
                                                    {{ass_strings.oneWord_level[store_system_langCode_v.val]}}
                                                    {{server_creatorData_byUserId_c[creatorMoreInfo_c.udsmi_userId_uid].ud_m_level_s()}}
                                                </div>

                                                (<div class="TQ_text_14px TQ_inline">
                                                {{format_bigNumber_fs(server_creatorData_byUserId_c[creatorMoreInfo_c.udsmi_userId_uid].ud_levelTotalPoints_n)}}
                                                {{ass_strings.oneWord_points[store_system_langCode_v.val]}}
                                            </div>)
                                            </div>


                                        </div>

                                        <div class="TQ_height_80px">
                                            {{format_strMaxLength_s(creatorMoreInfo_c.udsmi_cm_about_fs(store_system_langCode_v.val), 90)}}
                                        </div>

                                    </div>

                                </div>


                            </div>

                        </tq-link>
                    </td>
                </table>
            </div>
        </div>

        <!-- spacing -->
        <div class="TQ_padding_16px"></div>

        <!-- last reviews-->
        <div >
            <div class="TQ_text_32px TQ_margin_top_16px TQ_font_SecularOne TQ_bg_white TQ_text_capitalize">
                {{ass_strings.twoWords_lastReviews[store_system_langCode_v.val]}}
            </div>

            <div class="TQ_scrollable TQ_padding_8px">
                <table class="TQ_width_100p" :class="store_system_windowSizeType_ve.val > enum_screenSizesOptions_n.mobile && 'TQ_maxWidth_1500px TQ_center'">
                    <td class="TQ_verticalAlignMiddle" :class="store_system_windowSizeType_ve.val > enum_screenSizesOptions_n.mobile && 'TQ_inline'"  v-for="questReview_c in server_questReview_ac">
                        <tq-link :p_link_s="enum_moveToOptions.player_store_quest + '/' + questReview_c.qr_questId_uid" class="TQ_textColor_black TQ_text_remove_underline">
                            <div  class="TQ_borderRadius TQ_padding_8px TQ_bg_white TQ_margin_4px TQ_box_shadow TQ_width_300px TQ_clickable TQ_bg_hover_shadow2">

                                <div class="TQ_grid_col_auto1fr TQ_margin_top_4px">

                                    <div class="TQ_width_72px " v-if="server_creatorData_byUserId_c[questReview_c.qr_reviewerId_uid]">

                                        <fcc-avatar :p_ud_avatar_c="server_creatorData_byUserId_c[questReview_c.qr_reviewerId_uid].ud_avatar_c"
                                                    :key="$options.name + questReview_c.qr_reviewerId_uid"
                                                    class="TQ_width_44px TQ_borderRadius TQ_center TQ_inline"/>


                                        <div class="TQ_verticalAlignMiddle TQ_text_12px TQ_text_wordWrap">{{server_creatorData_byUserId_c[questReview_c.qr_reviewerId_uid].ud_name_s}} </div>
                                    </div>

                                    <div class="TQ_align_initial">

                                        <div class="TQ_margin_bottom_2px TQ_text_20px TQ_text_bold" v-if="server_questExplore_byQuestId_c[questReview_c.qr_questId_uid]">
                                            {{format_strMaxLength_s(server_questExplore_byQuestId_c[questReview_c.qr_questId_uid].cm_qex_getName_fs(store_system_langCode_v.val), 20    )}}
                                        </div>

                                        <si_-stars :rating="questReview_c.qr_overallRating_n" p_stars-width_s="16px" class="TQ_grid_verticalCenter TQ_margin_bottom_2px"/>

                                        <div class="TQ_height_60px TQ_align_initial">
                                            {{format_strMaxLength_s(questReview_c.qr_publicFeedback_s, 75)}}
                                        </div>

                                        <div class="TQ_text_12px TQ_textAlign_end">{{format_date_YYYY_MM_DD_hh_mm_fs(questReview_c.qr_timestamp_t)}} </div>

                                    </div>

                                </div>



                            </div>
                        </tq-link>
                    </td>
                </table>
            </div>
        </div>

        <!-- spacing -->
        <div class="TQ_padding_16px"></div>

    </div>

</template>

<script>


import {serverBig_questExplore_once_f, serverBig_questsExplore_getAll_f} from "@/scripts/Server/S_ServerFirestore";
    import {store_var, store_getStateValue_vo, store_setStateValue} from "@/store";
import {
    serverPre_cl_currentUserLovedQuests_get_f,
    serverPre_cl_currentUserLovedQuests_remove_f,
    server_getQuestExploreInfo_f,
    server_userLoveQuest_f,
    server_lastQuestReviewsPointers_get_last12_f,
    server_getUserQuestReview_fp,
    serverPre_subUserData_moreInfo_get_f,
    server_blogArticles_once_fp,
} from "@/scripts/Server/S_ServerPre";
    import {
        ass_image_store_fromHome,
        ass_image_store_outside, ass_img_filter_w,
        ass_img_oldMapCompass, ass_img_outdoor2, ass_img_selfGuided, ass_img_teamWork, ass_img_virtual,
    } from "@/assets/scripts/Ass_Files";
    import TqOnTopContainer from "../../../components/basic/TqOnTopContainer";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqImage from "../../../components/basic/TqImage";
    import {
        enum_langCodes,
        enum_moveToOptions, enum_questCategories,
        enum_screenSizesOptions_n
    } from "../../../../functions/src/shareCode/Share_S_Enum";

    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f,
        serverAuth_getOtherUserData_f
    } from "@/scripts/Server/S_ServerAuth";
    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";
    import TqLink from "@/components/basic/TqLink";
    import C_Player_Store_List from "@/views/v_player/v_player_store/c_Player_Store_List";
    import TqLeafletDisplaySimple from "@/components/maps/TqLeafletDisplaySimple";
    import Si_Stars from "@/components/a_smartIcons/si_Stars";
    import FccAvatar from "@/components/complex/TqAvatar";
import {
    format_bigNumber_fs,
    format_date_YYYY_MM_DD_hh_mm_fs, format_langCode_fs,
    format_strMaxLength_s
} from "../../../../functions/src/shareCode/Share_S_Format";
    import TqPopup from "@/components/basic/TqPopup";
    import TqToggleMultiOptions from "@/components/basic/TqToggleMultiOptions";
    import {file_getLangFlagByLangCode_fr} from "@/scripts/S_Files";
    import TqDropdown from "@/components/basic/TqDropdown";
import {helper_getDiffLevel_o} from "@/scripts/S_Helper";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
import {seo_creatSiteMap_f} from "@/scripts/S_seo";
import {date_setTimeout} from "@/scripts/S_Date";
import {gv_fun_env} from "../../../../functions/src/shareCode/Share_Ass_GlobalVariable";

    export default{
        name: "v_Player_Store_Main",
        components :{
            TqImgFillBlur,
            TqDropdown,
            TqToggleMultiOptions,
            TqPopup,
            FccAvatar,
            Si_Stars,
            TqLeafletDisplaySimple,
            C_Player_Store_List,
            TqLink,
            TqLoaderContainer,
            TqImage,
            TqOnTopContainer,
        },
        data(){
            return {

                // local data
                showLoader_questsExplores_b : true,
                categories_ao : [
                    {title_blc_s : ass_strings.oneWord_outside,         description_blc_s: ass_strings.sentence_storeDes_outside,       img_r : ass_img_outdoor2,   path_s : enum_moveToOptions.player_store_category + "/" + enum_questCategories.outside},
                    {title_blc_s : ass_strings.oneWord_virtual,         description_blc_s: ass_strings.sentence_storeDes_virtual,       img_r : ass_img_virtual,    path_s : enum_moveToOptions.player_store_category + "/" + enum_questCategories.virtual},
                    {title_blc_s : ass_strings.twoWords_teamBuilding,   description_blc_s: ass_strings.sentence_storeDes_teamBuilding,  img_r : ass_img_teamWork,   path_s : enum_moveToOptions.player_store_category + "/" + enum_questCategories.teamWork},
                    {title_blc_s : ass_strings.twoWords_selfGuided,     description_blc_s: ass_strings.sentence_storeDes_selfGuided,    img_r : ass_img_selfGuided, path_s : enum_moveToOptions.player_store_category + "/" + enum_questCategories.selfGuided},
                ],

                // store
                store_system_windowSizeType_ve  : store_getStateValue_vo(store_var.system_windowSizeType_e),
                store_system_langCode_v         : store_getStateValue_vo(store_var.system_langCode),
                store_system_currency_v         : store_getStateValue_vo(store_var.system_currency),
                store_storePath_vs              : store_getStateValue_vo(store_var.player_storePath_s),
                store_screenWidth_vn            : store_getStateValue_vo(store_var.system_screenWidth),

                // server
                server_currentUserData_c            : undefined,
                server_questsExplore_ac             : [],
                server_questExplore_byQuestId_c     : {},
                server_creatorData_byUserId_c       : {},
                server_creatorMoreInfo_byUserId_c   : {},
                server_questExploreInfo_byQuestId_c : {},
                server_lovedQuests_byQuestId_c      : {},
                server_oldGeoHash_byHash_s          : {},
                server_questReview_ac               : {},

                // imports
                ass_strings                     : ass_strings,

                format_date_YYYY_MM_DD_hh_mm_fs : format_date_YYYY_MM_DD_hh_mm_fs,
                format_strMaxLength_s           : format_strMaxLength_s,
                format_langCode_fs              : format_langCode_fs,
                format_bigNumber_fs              : format_bigNumber_fs,
                file_getLangFlagByLangCode_fr   : file_getLangFlagByLangCode_fr,
                helper_getDiffLevel_o           : helper_getDiffLevel_o,

                enum_langCodes                  : enum_langCodes,
                enum_screenSizesOptions_n       : enum_screenSizesOptions_n,
                enum_moveToOptions              : enum_moveToOptions,

                ass_img_oldMapCompass       : ass_img_oldMapCompass,
                ass_image_store_outside     : ass_image_store_outside,
                ass_image_store_fromHome    : ass_image_store_fromHome,
                ass_img_outdoor2            : ass_img_outdoor2,
                ass_img_virtual             : ass_img_virtual,
                ass_img_teamWork            : ass_img_teamWork,
                ass_img_selfGuided          : ass_img_selfGuided,


            }
        },
        computed : {
            co_mobileSize_b() {
                return this.store_system_windowSizeType_ve.val === enum_screenSizesOptions_n.mobile
            }
        },
        methods: {
            m_clickLoveQuest_f(questExplore_c){

                if(this.server_currentUserData_c == null){
                    return
                }

                let lovedQuest_b = this.server_lovedQuests_byQuestId_c[questExplore_c.qex_questId_uid] != null;

                server_userLoveQuest_f(this.server_currentUserData_c.ud_userId_uid, questExplore_c, lovedQuest_b)
            },


        },

        // ========= vueLifeCircle ===========
        async created(){

            // 1) get currentUserData
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c) => {

                this.server_currentUserData_c = userData_c

                if(userData_c == null){return}

                // 2) get currentUserLovedQuests
                serverPre_cl_currentUserLovedQuests_get_f(this.$options.name, userData_c,
                    (questPointer_c) => {
                        this.$set(this.server_lovedQuests_byQuestId_c, questPointer_c.qp_questId_uid, questPointer_c)
                    },
                    () => {},
                    (questId_uid) => {
                        this.$delete(this.server_lovedQuests_byQuestId_c,questId_uid)
                    })
            })

            // 3) get questExplore
            serverBig_questsExplore_getAll_f({filterByActive_b: true,
                cb_f :(questExplore_ac)=>{
                    this.server_questsExplore_ac = questExplore_ac
                    this.showLoader_questsExplores_b = false
                    let creatorsData_ac = []
                    let getCreatorsCount_n = 0

                    questExplore_ac.forEach(questExplore_c => {

                        // 4) get questExplore creatorUserData
                        if(this.server_creatorData_byUserId_c[questExplore_c.qex_creatorId_uid] === undefined){
                            this.$set(this.server_creatorData_byUserId_c,questExplore_c.qex_creatorId_uid, null);
                            getCreatorsCount_n ++

                            serverAuth_getOtherUserData_f(questExplore_c.qex_creatorId_uid, userData_c =>{
                                creatorsData_ac.push(userData_c)
                                this.$set(this.server_creatorData_byUserId_c, questExplore_c.qex_creatorId_uid, userData_c);
                            })

                            serverPre_subUserData_moreInfo_get_f({userId_uid : questExplore_c.qex_creatorId_uid, cb_f : userMoreInfo_c =>{
                                    this.$set(this.server_creatorMoreInfo_byUserId_c, questExplore_c.qex_creatorId_uid, userMoreInfo_c);
                                }})
                        }

                        // 5) get questExplore moreInfo
                        server_getQuestExploreInfo_f(questExplore_c, (questExploreInfo_c) => {
                            this.$set(this.server_questExploreInfo_byQuestId_c, questExploreInfo_c.qexi_questId_uid, questExploreInfo_c)
                        })
                    });

                    if(gv_fun_env.createSiteMap_b){
                        date_setTimeout(() => {
                            server_blogArticles_once_fp(true, (articlesData_byArticleId_c) => {
                                seo_creatSiteMap_f(creatorsData_ac, this.server_creatorMoreInfo_byUserId_c, [], [])
                            })
                        }, this.$options.name, 5000)
                    }



                }});

            // reviews
            server_lastQuestReviewsPointers_get_last12_f((lastQuestReviewsPointers_ac) => {
                this.server_questReview_ac = []
                lastQuestReviewsPointers_ac.forEach(lastQuestReviewsPointers_c => {
                    server_getUserQuestReview_fp(lastQuestReviewsPointers_c.lqrp_questType_e, lastQuestReviewsPointers_c.lqrp_questId_uid, lastQuestReviewsPointers_c.lqrp_reviewerId_uid,
                        (questReview_c) => {
                            this.server_questReview_ac.unshift(questReview_c)
                        })

                    serverBig_questExplore_once_f(lastQuestReviewsPointers_c.lqrp_questId_uid, false, (questExplore_c) => {
                        this.$set(this.server_questExplore_byQuestId_c, lastQuestReviewsPointers_c.lqrp_questId_uid, questExplore_c)
                    })

                    if(this.server_creatorData_byUserId_c[lastQuestReviewsPointers_c.lqrp_reviewerId_uid] == null){
                        serverAuth_getOtherUserData_f(lastQuestReviewsPointers_c.lqrp_reviewerId_uid, (userData_c) => {
                            this.$set(this.server_creatorData_byUserId_c, lastQuestReviewsPointers_c.lqrp_reviewerId_uid, userData_c)
                        })
                    }

                })
            })

        },
        destroyed(){
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            if(this.server_currentUserData_c){
                serverPre_cl_currentUserLovedQuests_remove_f(this.$options.name, this.server_currentUserData_c.ud_userId_uid)
            }

        }

    }


</script>

<style scoped lang="scss">

    .lc_topImage{
        &.lc_laptop{
            min-width: 100%;
            max-height: 450px;

        }
        &.lc_tablet{
            min-width: 100%;
            max-height: 450px;
        }
        &.lc_mobile{
            max-height: 300px;
        }
    }

    .lc_title1{
        line-height: 100px;
        //-webkit-text-stroke: 2px purple;

    }


    /* animation */
    .lc_stats1{
        animation-name: opacityShow;
        animation-delay: 4s;
        animation-duration: 1s;
        animation-fill-mode: forwards;
        opacity: 0;
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
    }
    .lc_stats2{
        animation-name: opacityShow;
        animation-delay: 4.5s;
        animation-duration: 1s;
        animation-fill-mode: forwards;
        opacity: 0;
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
    }
    .lc_stats3{
        animation-name: opacityShow;
        animation-delay:5s;
        animation-duration: 1s;
        animation-fill-mode: forwards;
        opacity: 0;
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
    }
    @keyframes opacityShow {
        from {
            opacity: 0;
            transform: translateY(20%);
            -webkit-transform: translateY(20%);
        }
        to{
            opacity: 1;
            transform: translateY(0);
            -webkit-transform: translateY(0);
        }
    }


    .lc_mobileFilterButton{
        position: fixed;
        bottom: var(--bottomBar);
    }


</style>
